import type { UUID, ISODateString, Nullable } from './common';

export type ContractStatus = 'requested' | 'received' | 'signed';

export interface Contract {
  id: UUID;
  itemId: Nullable<UUID>;
  projectId: Nullable<UUID>;
  quoteId: Nullable<UUID>;
  status: ContractStatus;
  totalAmount: number;
  isActive: boolean;
  signedAt: Nullable<ISODateString>;
  notes: Nullable<string>;
  sourceDocumentUrl: Nullable<string>;
  sourceDocumentMimeType: Nullable<string>;
  rawPaymentTerms: Nullable<string>;
  extractionSnapshot: unknown;
  batchId: Nullable<UUID>;
  vendorName: Nullable<string>;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export interface Payment {
  id: UUID;
  contractId: UUID;
  description: string;
  amount: number;
  dueDate: Nullable<ISODateString>;
  dueDateDescription: Nullable<string>;
  paidAt: Nullable<ISODateString>;
  sortOrder: number;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export interface Invoice {
  id: UUID;
  contractId: UUID;
  invoiceNumber: Nullable<string>;
  issuedAt: Nullable<ISODateString>;
  totalAmount: number;
  notes: Nullable<string>;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export interface ContractWithDetails extends Contract {
  payments: Payment[];
  invoices: Invoice[];
}

export const CONTRACT_STATUS_LABELS: Record<ContractStatus, string> = {
  requested: 'Requested',
  received: 'Received',
  signed: 'Signed',
};
